import { isEditorContentEmpty } from '@crm/utils'
import { TipTapEditor } from '@shared/components/TipTapEditor'
import { useLocales } from '@shared/locales'
import { Form, Input, Radio } from 'antd'

export const FormEmailTemplate = () => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="title"
        label={t('account_settings.title')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="subject"
        label={t('account_settings.subject')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="is_public" label={t('account_settings.visibility')}>
        <Radio.Group
          options={[
            {
              label: t('account_settings.public'),
              value: true
            },
            {
              label: t('account_settings.private'),
              value: false
            }
          ]}
        />
      </Form.Item>

      <Form.Item
        name="message"
        label={t('account_settings.message')}
        rules={[
          {
            required: true,
            validateTrigger: 'change',
            validator: (_, value) =>
              isEditorContentEmpty(value)
                ? Promise.reject(
                    new Error(t('account_settings.this_field_is_required'))
                  )
                : Promise.resolve()
          }
        ]}
      >
        <TipTapEditor />
      </Form.Item>
    </>
  )
}
